"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _core = require("@material-ui/core");

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

var _KeyboardArrowUp = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowUp"));

var React = _interopRequireWildcard(require("react"));

var _ = require("../../..");

var css = _interopRequireWildcard(require("./Menu.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)({
  muiMenuPaper: function muiMenuPaper(props) {
    return {
      boxShadow: "0 4px 8px ".concat(props.theme.colors.neutral[200])
    };
  },
  muiPopoverPaper: function muiPopoverPaper(props) {
    return {
      marginTop: props.dense ? 3 : 4
    };
  },
  muiButtonRoot: function muiButtonRoot(props) {
    return {
      minWidth: 'fit-content !important',
      height: props.dense ? 'fit-content !important' : 'inherit',
      fontSize: "".concat(props.dense ? 13 : 14, " !important"),
      borderRadius: "".concat(props.dense ? props.theme.radii.md : props.theme.radii.lg, " !important"),
      padding: "".concat(props.dense ? '7px 16px' : '14px 32px', " !important")
    };
  }
});

var Menu = function Menu(_ref) {
  var label = _ref.label,
      options = _ref.options,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$dense = _ref.dense,
      dense = _ref$dense === void 0 ? false : _ref$dense,
      onClick = _ref.onClick,
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _ref$anchorOrigin,
      _ref$transformOrigin = _ref.transformOrigin,
      transformOrigin = _ref$transformOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'center'
  } : _ref$transformOrigin,
      props = _objectWithoutProperties(_ref, ["label", "options", "color", "dense", "onClick", "anchorOrigin", "transformOrigin"]);

  var _useState = (0, React.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var isDisabled = !options || (options === null || options === void 0 ? void 0 : options.length) <= 0;
  var theme = (0, _react.useTheme)();
  var styles = useStyles({
    theme: theme,
    dense: dense
  });

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);

    if (onClick) {
      onClick(event);
    }
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_.Buttons.Basic, _objectSpread(_objectSpread({
      "aria-controls": "mui-menu",
      "aria-haspopup": "true",
      onClick: handleClick,
      color: color,
      variant: "contained",
      disableRipple: true,
      disabled: isDisabled,
      classes: {
        root: styles.muiButtonRoot
      },
      css: css.menuButton(dense, Boolean(anchorEl))
    }, props), {}, {
      children: [label, anchorEl && (0, _jsxRuntime.jsx)(_SvgIcon["default"], {
        fontSize: "small",
        component: _KeyboardArrowUp["default"]
      }), !anchorEl && (0, _jsxRuntime.jsx)(_SvgIcon["default"], {
        fontSize: "small",
        component: _KeyboardArrowDown["default"]
      })]
    })), (0, _jsxRuntime.jsx)(_Menu["default"], {
      id: "mui-menu",
      anchorEl: anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      getContentAnchorEl: null,
      anchorOrigin: anchorOrigin,
      transformOrigin: transformOrigin,
      classes: {
        paper: styles.muiMenuPaper
      },
      MenuListProps: {
        disablePadding: true
      },
      PopoverClasses: {
        paper: styles.muiPopoverPaper
      },
      children: (options === null || options === void 0 ? void 0 : options.length) > 0 && options.map(function (option) {
        return (0, _jsxRuntime.jsx)(_MenuItem["default"], {
          css: css.menuItem(option.highlight),
          disableRipple: true,
          onClick: function onClick(e) {
            handleClose();

            if (typeof option.onClick !== 'undefined') {
              option.onClick(e);
            }
          },
          children: option.label
        }, option.label);
      })
    })]
  });
};

var _default = Menu;
exports["default"] = _default;